import React from "react";
import Window from "./Window";
import ProvablyFair from "./ProvablyFair";

import "./GameRules.css";
import Common from "../Common";
import BetControl from "../BetControl";

export default class GameRules extends React.Component<GameRules.Props, GameRules.State>
{


    constructor(props: GameRules.Props)
    {
        super(props);
    }


    clickProvablyFair()
    {
        app.addWindow(<ProvablyFair/>)
    }


    render()
    {
        const lang = window.lang.shared.modals.rules;
        const lShared = window.lang.shared;

        return (
            <Window
                id="gameRules"
                title={lShared.game_rules}
            >
                <div className="label">
                    {lang["game-rules"]["main-text"]}
                </div>

                <div className="label">
                    <span 
                        className="link"
                        onClick={this.clickProvablyFair.bind(this)}
                    >
                        {lang["game-rules"].link}
                    </span>
                </div>

                <h1>
                    {lShared.how_to_play}
                </h1>

                <div className="video">
                    <video
                        src={Common.getVideoUrl()}
                        controls
                        preload="none"
                        poster="gfx/video_preview.png"
                        controlsList="nodownload"
                    />
                </div>

                <h2>
                    {lang["game-rules"].steps.title}
                </h2>

                <div className="gameSteps">
                    <div className="step">
                        <div className="num">
                            01
                        </div>
                        <div className="image_0" id="bet_controls">
                            <BetControl
                                static
                                index={666}
                                onViewUpdate={() => {}}
                                view={{
                                    autoBet: false,
                                    autoCashout: false,
                                    betState: "bet",
                                    betStatePending: false,
                                    lastBetClicked: null,
                                    menuIdx: 0
                                }}
                            />
                        </div>
                        <div className="description">
                            <div className="icon"></div>
                            <div className="label">
                                <span className="title">
                                    {lShared.bet}
                                </span>
                                {lang["game-rules"].steps["first-step"]}
                            </div>
                        </div>
                    </div>

                    <div className="step">
                        <div className="num">
                            02
                        </div>
                        <div className="image_1"></div>
                        <div className="description">
                            <div className="icon"></div>
                            <div className="label">
                                <span className="title">
                                    {lShared.watch}
                                </span>
                                {lang["game-rules"].steps["second-step"]}
                            </div>
                        </div>
                    </div>

                    <div className="step">
                        <div className="num">
                            03
                        </div>
                        <div className="image_2"></div>
                        <div className="description">
                            <div className="icon"></div>
                            <div className="label">
                                <span className="title">
                                    {lShared.cash_out}
                                </span>
                                {lang["game-rules"].steps["third-step"]}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="label stepOutro">
                    {lang["game-rules"].steps.text}
                </div>

                <h3>
                    {lang["game-rules"].details.title}
                </h3>
                <div className="list">
                    <div className="item">
                        {lang["game-rules"].details.point1}
                    </div>
                    <div className="item">
                        {lang["game-rules"].details.point2}
                    </div>
                    <div className="item">
                        {lang["game-rules"].details["point3-1"]}
                        <span className="icon_fair"></span>
                        {lang["game-rules"].details["point3-2"]}
                    </div>
                </div>

                <h1 className="gameFunctions">
                    {lang["game-rules"]["game-functions"].title}
                </h1>

                {/* BET CASHOUT */}
                <h3>
                    {lang["game-rules"]["game-functions"]["bet-cashout"].title}
                </h3>
                <div className="list">
                    <div className="item">
                        {lang["game-rules"]["game-functions"]["bet-cashout"].point1}
                    </div>
                    <div className="item">
                        {lang["game-rules"]["game-functions"]["bet-cashout"].point5}
                    </div>
                    <div className="item">
                        {lang["game-rules"]["game-functions"]["bet-cashout"].point6}
                    </div>
                    <div className="item">
                        {lang["game-rules"]["game-functions"]["bet-cashout"].point2}
                    </div>
                    <div className="item">
                        {lang["game-rules"]["game-functions"]["bet-cashout"].point3}
                    </div>
                    <div className="item">
                        {lang["game-rules"]["game-functions"]["bet-cashout"].point4}
                    </div>
                </div>

                {/* AUTO PLAY - TWO FEATURES AVAILABLE */}
                <h3>
                    {lang["game-rules"]["game-functions"]["auto-play-auto-cashout"].title}
                </h3>
                <div className="list">
                    <div className="item">
                        {lang["game-rules"]["game-functions"]["auto-play-auto-cashout"].point7}
                    </div>
                    <div className="item">
                        {lang["game-rules"]["game-functions"]["auto-play-auto-cashout"].point6}
                    </div>
                    <div className="item">
                        {lang["game-rules"]["game-functions"]["auto-play-auto-cashout"].point5}
                    </div>
                </div>
                
                {/* LIVE BETS STATISTICS */}
                <h3>
                    {lang["game-rules"]["game-functions"]["live-bets-statistics"].title}
                </h3>
                <div className="list">
                    <div className="item">
                        {lang["game-rules"]["game-functions"]["live-bets-statistics"].point1}
                    </div>
                    <div className="item">
                        {lang["game-rules"]["game-functions"]["live-bets-statistics"].point2}
                    </div>
                    <div className="item">
                        {lang["game-rules"]["game-functions"]["live-bets-statistics"].point3}
                    </div>
                </div>

                {/* IN GAME CHAT */}
                <h3>
                    {lang["game-rules"]["game-functions"]["in-game-chat"].title}
                </h3>
                <div className="list">
                    <div className="item">
                        {lang["game-rules"]["game-functions"]["in-game-chat"].point1}
                    </div>
                </div>

                {/* FREE BETS */}
                <h3 className="text-capitalize">
                    {lShared.free_bets}
                </h3>
                <div className="list">
                    <div className="item">
                        {lang["game-rules"]["game-functions"]["free-bets"].point1}
                    </div>
                </div>

                {/* RAIN - ENABLE / DISABLE */}
                {/* <h3>
                    {lang["game-rules"]["game-functions"]["rain-feature"].title}
                </h3>
                <div className="list">
                    <div className="item">
                        {lang["game-rules"]["game-functions"]["rain-feature"].point1}
                    </div>
                </div> */}

                {/* RANDOMISATION */}
                <h3>
                    {lang["game-rules"]["game-functions"]["randomization"].title}
                </h3>
                <div className="list">
                    <div className="item">
                        {lang["game-rules"]["game-functions"]["randomization"].point1}
                        <span className="link"
                            onClick={this.clickProvablyFair.bind(this)}
                        >
                            {lang["game-rules"].link}
                        </span>
                    </div>
                    <div className="item">
                        {lang["game-rules"]["game-functions"]["randomization"].point2}
                    </div>
                    <div className="item">
                        {lang["game-rules"]["game-functions"]["randomization"]["point3-1"]}
                        <span className="icon_fair"></span>
                        {lang["game-rules"]["game-functions"]["randomization"]["point3-2"]}
                    </div>
                </div>

                {/* GAME MENU */}
                <h3>
                    {lang["game-rules"]["game-functions"]["game-menu"].title}
                </h3>
                <div className="list">
                    <div className="item">
                        {lang["game-rules"]["game-functions"]["game-menu"].point1}
                    </div>
                    <div className="item">
                        {lang["game-rules"]["game-functions"]["game-menu"].point2}
                    </div>
                    <div className="item">
                        {lang["game-rules"]["game-functions"]["game-menu"].point3}
                    </div>
                    <div className="item">
                        {lang["game-rules"]["game-functions"]["game-menu"].point4}
                    </div>
                    <div className="item">
                        {lang["game-rules"]["game-functions"]["game-menu"].point5}
                    </div>
                    <div className="item">
                        {lang["game-rules"]["game-functions"]["game-menu"].point6}
                    </div>
                    <div className="item">
                        {lang["game-rules"]["game-functions"]["game-menu"].point7}
                    </div>
                </div>

                {/* OTHER */}
                <h3>
                    {lang["game-rules"]["game-functions"]["other"].title}
                </h3>
                <div className="list">
                    <div className="item">
                        {lang["game-rules"]["game-functions"]["other"].point1}
                    </div>
                    <div className="item">
                        {lang["game-rules"]["game-functions"]["other"].point2}
                    </div>
                </div>
            </Window>
        )
    }


}


export namespace GameRules
{


    export interface Props
    {

    }


    export interface State
    {
        coin_denominations: Array<number>;
        bet_step: number;
    }


}